<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.ADD_EQUIPMENT' | translate }}</h1>
  <mat-divider></mat-divider>

  @if (missingRequiredFields$ | async; as missingRequiredFields) {
    @if (missingRequiredFields.length > 0) {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
        <ul>
          @for (field of missingRequiredFields; track field.code) {
            <li>{{ field.label }}</li>
          }
        </ul>
      </mat-dialog-content>
      <mat-dialog-actions class="center">
        <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
      </mat-dialog-actions>
    } @else {
      <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
        <form-builder [form]="form"
                      [formId]="formId"
                      [eventsOrigin]="eventsOrigin"
                      [permissionsForEdition]="permissionsForEdition"
                      [displayHeader]="false">
        </form-builder>
      </mat-dialog-content>
    }
  } @else {
    <spinner></spinner>
  }
</div>
